import { DependencyList, useEffect, useState } from 'react'
import { FirebaseDocRefType } from 'firebase/index'
import { fetchFanAmount } from 'lib/user'

export const useSkip = (effect: () => void, deps: DependencyList, times: number) => {
  const [_times, setTimes] = useState<number>(0)
  useEffect(() => {
    if (_times >= times) {
      return effect()
    } else {
      setTimes(_times + 1)
    }
  }, deps)
}

export const useFixedBackface = (fixed: boolean, deps: DependencyList) => {
  useEffect(() => {
    /**
     * 表示されているスクロールバーとの差分を計測し、背面固定時はその差分body要素に余白を生成する
     */
    const scrollbarWidth = window.innerWidth - document.body.clientWidth
    document.body.style.paddingRight = fixed ? `${scrollbarWidth}px` : ''

    /**
     * スクロール位置を取得する要素を出力する(`html`or`body`)
     */
    const scrollingElement = () => {
      const browser = window.navigator.userAgent.toLowerCase()
      if ('scrollingElement' in document) return document.scrollingElement
      // @ts-ignore
      if (browser.indexOf('webkit') > 0) return document.body
      // @ts-ignore
      return document.documentElement
    }

    /**
     * 変数にスクロール量を格納
     */
    // @ts-ignore
    const scrollY = fixed ? scrollingElement().scrollTop : parseInt(document.body.style.top || '0')

    /**
     * CSSで背面を固定
     */
    const styles = {
      height: '100vh',
      left: '0',
      overflow: 'hidden',
      position: 'fixed',
      top: `${scrollY * -1}px`,
      width: '100vw',
    }

    Object.keys(styles).forEach((key) => {
      // @ts-ignore
      document.body.style[key] = fixed ? styles[key] : ''
    })

    /**
     * 背面固定解除時に元の位置にスクロールする
     */
    if (!fixed) window.scrollTo(0, scrollY * -1)
  }, deps)
}

export const useDisplayScrollPosition = (isDisplayed: boolean, handleDisplayed: (state: boolean) => void): void => {
  useEffect(() => {
    const position = window.pageYOffset

    if (position > 100 && !isDisplayed) {
      handleDisplayed(true)
    }
    if (position <= 100 && isDisplayed) {
      handleDisplayed(false)
    }
  })
}
